import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {message} from "antd";
import {medicalSuppliesService} from "api";
import Notification from "components/common/notification/notification";
import {LOAI_FORM, LOAI_PHIEU_VTYT, TT_PHIEU_VTYT} from "types/enums";

type State = {
  suppliesNameList: any[];
  suppliesGroupList: any[];
  suppliesStoreList: any[];
  suppliesStoreRes: any;
  supplierList: any[];
  manufacturerList: any[];
  manufacturedCountryList: any[];
  medicalSuppliesList: any[];
  selectedMedicalSupplies: any[];
  detailRecord: any;
  statusPhieu: TT_PHIEU_VTYT;
  isReloadApi: boolean;
  selectedRecord: any;
  idPhieu: number | string;
  khoKiemKeId: any;
  typeForm: LOAI_FORM;
  vTUnitConversionList: any;
  detailInventory: any;
  typePhieu: LOAI_PHIEU_VTYT;
  nguonVTYTList: any[];
  vTYTSearchKeyList: any[];
  donViApList: any[];
  medicalSuppliesTotal: number;
  vTYTSearchKeyTotal: number;
  quyCachList: any[];
  donViTinhList: any[];
};

const initialState: State = {
  suppliesNameList: [],
  suppliesGroupList: [],
  suppliesStoreList: null,
  suppliesStoreRes: null,
  supplierList: [],
  manufacturerList: [],
  manufacturedCountryList: [],
  medicalSuppliesList: [],
  selectedMedicalSupplies: [],
  detailRecord: null,
  statusPhieu: null,
  isReloadApi: false,
  selectedRecord: null,
  idPhieu: null,
  khoKiemKeId: null,
  typeForm: null,
  vTUnitConversionList: null,
  detailInventory: null,
  typePhieu: null,
  nguonVTYTList: null,
  vTYTSearchKeyList: null,
  donViApList: null,
  medicalSuppliesTotal: 0,
  vTYTSearchKeyTotal: 0,
  quyCachList: null,
  donViTinhList: null,
};

export const slice = createSlice({
  name: "medicalSupplies",
  initialState: initialState,
  reducers: {
    setSuppliesNameList: (state = initialState, action: PayloadAction<any>) => {
      state.suppliesNameList = action.payload.medicalSuppliesNameData;
    },
    setListSuppliesGroup: (
      state = initialState,
      action: PayloadAction<any>
    ) => {
      state.suppliesGroupList = action.payload.suppliesGroupData;
    },
    setListSuppliesStore: (
      state = initialState,
      action: PayloadAction<any>
    ) => {
      state.suppliesStoreList = action.payload.suppliesStoreData?.data || [];
      state.suppliesStoreRes = action.payload.suppliesStoreData || {};
    },
    setListSupplier: (state = initialState, action: PayloadAction<any>) => {
      state.supplierList = action.payload.supplierData;
    },
    setListManufacturer: (state = initialState, action: PayloadAction<any>) => {
      state.manufacturerList = action.payload.manufacturerData;
    },
    setListManufacturedCountry: (
      state = initialState,
      action: PayloadAction<any>
    ) => {
      state.manufacturedCountryList = action.payload.manufacturedCountryData;
    },
    setListMedicalSupplies: (
      state = initialState,
      action: PayloadAction<any>
    ) => {
      state.medicalSuppliesList = action.payload.medicalSuppliesData;
      state.medicalSuppliesTotal = action.payload.medicalSuppliesDataTotal;
    },
    setSelectedMedicalSupplies: (
      state = initialState,
      action: PayloadAction<any>
    ) => {
      return {...state, selectedMedicalSupplies: action.payload};
    },
    setDetailRecord: (state = initialState, action: PayloadAction<any>) => {
      return {...state, detailRecord: action.payload};
    },
    setStatusPhieu: (state = initialState, action: PayloadAction<any>) => {
      return {...state, statusPhieu: action.payload};
    },
    setIsReloadApi: (state = initialState, action: PayloadAction<any>) => {
      return {...state, isReloadApi: action.payload};
    },
    setSelectedRecord: (state = initialState, action: PayloadAction<any>) => {
      return {...state, selectedRecord: action.payload};
    },
    setIdPhieu: (state = initialState, action: PayloadAction<any>) => {
      return {...state, idPhieu: action.payload};
    },
    setKhoKiemKeId: (state = initialState, action: PayloadAction<any>) => {
      return {...state, khoKiemKeId: action.payload};
    },
    setTypeForm: (state = initialState, action: PayloadAction<any>) => {
      return {...state, typeForm: action.payload};
    },
    setVTUnitConversion: (state = initialState, action: PayloadAction<any>) => {
      state.vTUnitConversionList = action.payload.vTUnitConversionData;
    },
    setDetailInventory: (state = initialState, action: PayloadAction<any>) => {
      return {...state, detailInventory: action.payload};
    },
    setTypePhieu: (state = initialState, action: PayloadAction<any>) => {
      return {...state, typePhieu: action.payload};
    },
    setListNguonVTYT: (state = initialState, action: PayloadAction<any>) => {
      state.nguonVTYTList = action.payload.nguonVTYTData || [];
    },
    setListVTYTSearchKey: (
      state = initialState,
      action: PayloadAction<any>
    ) => {
      state.vTYTSearchKeyList = action.payload.vTYTSearchKeyData || [];
      state.vTYTSearchKeyTotal = action.payload.vTYTSearchKeyDataTotal;
    },
    setListDonViAp: (state = initialState, action: PayloadAction<any>) => {
      state.donViApList = action.payload.donViApData;
    },
    setListQuyCach: (state = initialState, action: PayloadAction<any>) => {
      state.quyCachList = action.payload.quyCachData;
    },
    setListDonViTinh: (state = initialState, action: PayloadAction<any>) => {
      state.donViTinhList = action.payload.donViTinhData;
    },
  },
});

export const {
  setSuppliesNameList,
  setListSuppliesGroup,
  setListSuppliesStore,
  setListSupplier,
  setListManufacturer,
  setListManufacturedCountry,
  setListMedicalSupplies,
  setSelectedMedicalSupplies,
  setDetailRecord,
  setStatusPhieu,
  setIsReloadApi,
  setSelectedRecord,
  setIdPhieu,
  setKhoKiemKeId,
  setTypeForm,
  setVTUnitConversion,
  setDetailInventory,
  setTypePhieu,
  setListNguonVTYT,
  setListVTYTSearchKey,
  setListDonViAp,
  setListQuyCach,
  setListDonViTinh,
} = slice.actions;

export const getSuppliesNameAPI = () => {
  return async dispatch => {
    try {
      const medicalSuppliesNameData =
        (await medicalSuppliesService.getListSuppliesName({isEmpty: false})) ||
        [];
      dispatch(
        setSuppliesNameList({
          medicalSuppliesNameData,
        })
      );
    } catch (error) {
      Notification("error", "Đã có lỗi xảy ra khi lấy danh sách tên vật tư");
    }
  };
};
export const getListSuppliesGroupAPI = () => {
  return async dispatch => {
    try {
      const suppliesGroupData =
        (await medicalSuppliesService.getListSuppliesGroup()) || [];
      dispatch(
        setListSuppliesGroup({
          suppliesGroupData,
        })
      );
    } catch (error) {
      Notification(
        "error",
        "Đã có lỗi xảy ra khi lấy danh sách tên nhóm vật tư"
      );
    }
  };
};
export const getSuppliesStoreAPI = params => {
  return async dispatch => {
    try {
      const suppliesStoreData =
        await medicalSuppliesService.getListSuppliesStore(params);
      dispatch(
        setListSuppliesStore({
          suppliesStoreData,
        })
      );
    } catch (error) {
      Notification("error", "Đã có lỗi xảy ra khi lấy danh sách kho vật tư");
    }
  };
};
export const getSupplierAPI = () => {
  return async dispatch => {
    try {
      const supplierData = await medicalSuppliesService.getListSupplier();
      dispatch(
        setListSupplier({
          supplierData,
        })
      );
    } catch (error) {
      Notification(
        "error",
        "Đã có lỗi xảy ra khi lấy danh sách các nhà cung cấp"
      );
    }
  };
};
export const getManufacturerAPI = () => {
  return async dispatch => {
    try {
      const manufacturerData =
        (await medicalSuppliesService.getListManufacturer()) || [];
      dispatch(
        setListManufacturer({
          manufacturerData,
        })
      );
    } catch (error) {
      Notification(
        "error",
        "Đã có lỗi xảy ra khi lấy danh sách các hãng sản xuất"
      );
    }
  };
};
export const getManufacturedCountryAPI = () => {
  return async dispatch => {
    try {
      const manufacturedCountryData =
        (await medicalSuppliesService.getListManufacturedCountry()) || [];
      dispatch(
        setListManufacturedCountry({
          manufacturedCountryData,
        })
      );
    } catch (error) {
      Notification(
        "error",
        "Đã có lỗi xảy ra khi lấy danh sách các nước sản xuất"
      );
    }
  };
};
export const searchMedicalSuppliesAPI = params => {
  return async dispatch => {
    console.log("searchMedicalSuppliesAPI");
    try {
      const medicalSuppliesData =
        await medicalSuppliesService.searchMedicalSupplies(params);
      console.log(medicalSuppliesData);
      dispatch(
        setListMedicalSupplies({
          medicalSuppliesData: medicalSuppliesData.data,
          medicalSuppliesDataTotal: medicalSuppliesData.total,
        })
      );
    } catch (error) {
      // Notification("error", "Đã có lỗi xảy ra khi lấy danh sách vật tư");
    }
  };
};
export const postImportFormAPI = params => {
  return async dispatch => {
    try {
      const medicalSuppliesData = await medicalSuppliesService.updateImportForm(
        params
      );
      dispatch(
        setListMedicalSupplies({
          medicalSuppliesData,
        })
      );
    } catch (error) {
      Notification("error", "Đã có lỗi xảy ra khi cập nhật danh sách vật tư");
    }
  };
};
export const getVTUnitConversionAPI = params => {
  return async dispatch => {
    try {
      const vTUnitConversionData =
        await medicalSuppliesService.getVTUnitConversion(params);
      dispatch(
        setVTUnitConversion({
          vTUnitConversionData,
        })
      );
    } catch (error) {
      Notification("error", "Đã có lỗi xảy ra khi lấy đơn vị vật tư");
    }
  };
};
export const getNguonVTYTAPI = () => {
  return async dispatch => {
    try {
      const nguonVTYTData = await medicalSuppliesService.getListNguonVTYT();
      dispatch(
        setListNguonVTYT({
          nguonVTYTData,
        })
      );
    } catch (error) {
      Notification("error", "Đã có lỗi xảy ra khi lấy danh sách nguồn vật tư");
    }
  };
};
export const getStoreVTYTSearchKeyAPI = params => {
  return async dispatch => {
    try {
      const vTYTSearchKeyData =
        await medicalSuppliesService.getListVTYTSearchKey(params);
      dispatch(
        setListVTYTSearchKey({
          vTYTSearchKeyData: vTYTSearchKeyData.data,
          vTYTSearchKeyDataTotal: vTYTSearchKeyData.total,
        })
      );
    } catch (error) {
      Notification("error", "Đã có lỗi xảy ra khi lấy danh sách kho vật tư");
    }
  };
};
export const getListVTYTAPI = params => {
  return async dispatch => {
    try {
      const vTYTSearchKeyData =
        (await medicalSuppliesService.getListVTYT(params)) || [];
      dispatch(
        setListVTYTSearchKey({
          vTYTSearchKeyData: vTYTSearchKeyData,
          vTYTSearchKeyDataTotal: vTYTSearchKeyData.length,
        })
      );
    } catch (error) {
      Notification("error", "Đã có lỗi xảy ra khi lấy danh sách kho vật tư");
    }
  };
};
export const getDonViApAPI = params => {
  return async dispatch => {
    try {
      const donViApData =
        (await medicalSuppliesService.getListDonViAp(params)) || [];
      dispatch(
        setListDonViAp({
          donViApData,
        })
      );
    } catch (error) {
      Notification("error", "Đã có lỗi xảy ra khi lấy danh sách đơn vị");
    }
  };
};
export const getQuyCachAPI = () => {
  return async dispatch => {
    try {
      const quyCachData = await medicalSuppliesService.getQuyCach();
      dispatch(
        setListQuyCach({
          quyCachData,
        })
      );
    } catch (error) {
      Notification("error", "Đã có lỗi xảy ra khi lấy danh sách quy cách");
    }
  };
};
export const getDonViTinhAPI = () => {
  return async dispatch => {
    try {
      const donViTinhData = await medicalSuppliesService.getDonViTinh();
      dispatch(
        setListDonViTinh({
          donViTinhData,
        })
      );
    } catch (error) {
      Notification("error", "Đã có lỗi xảy ra khi lấy danh sách đơn vị tính");
    }
  };
};
export const updateDetailLo = params => {
  return async dispatch => {
    try {
      const res = (await medicalSuppliesService.updateDetailLo(params)) || null;
      Notification("success", "Đã cập nhật thông tin lô");
    } catch (error) {
      Notification("error", "Đã có lỗi xảy ra khi cập nhật thông tin lô");
    }
  };
};
export const medicalSuppliesStore = state => state.medicalSupplies;

export default slice.reducer;
